import Vasya1 from '../../../Media/BSD/Tanakayu/Tanakayu Vasya.webp'
import Vasya2 from '../../../Media/BSD/Tanakayu/Tanakayu Vasya.webp'





const Vasyaimages =[
Vasya1,Vasya2
]

export default Vasyaimages;